import hasPermi from "./permissions/index.js"

function directive(app) {
    app.directive('hasPermi', hasPermi)
}

export default directive;